import { DEMO_EMAIL, ORG_TYPES } from "components/Common/Constants";
import Loading from 'components/Common/Loading';
import SCOOTER3 from "assets/images/red.svg";
import placeHolderImage from "assets/images/placeHolder.svg";
import { Row, Col } from "antd";


const VehicleImageWidget = ({vehicleDetails, showDetails=true, showOdometer=false}) =>{
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
   
    const getImageUrl = () => {
        if (
          userDetails?.mainOrganisation?.type === ORG_TYPES.ADMINISTRATOR &&
          userDetails?.email === DEMO_EMAIL
        ) {
          return SCOOTER3;
        } else if (vehicleDetails?.images?.length > 0) {
          const item = vehicleDetails?.images?.find(
            (item) => item.tag === "DEFAULT"
          );
          return item ? item.url : null;
        } else {
          return null;
        }
    };

    return(
      <div>
        {!vehicleDetails?.images && <Loading />}
        {vehicleDetails?.images && (
            <div className="vehicle-img" >
              {vehicleDetails?.images &&
                  (getImageUrl() === null ? (
                  <img alt="Brand" src={placeHolderImage} width="100%" />
                  ) : (
              <img
                  alt="Brand"
                  src={getImageUrl()}
                  width="100%"
                  height="auto"
              />
              ))}
            </div>
        )}
          <Row>
          <Col span={24}>
          {showDetails &&
              <div style={{display: 'flex', paddingTop: '10px', justifyContent: 'center'}}>
                  <span style={{fontSize: '24px', alignItems: 'center',fontWeight: 600}}>
                  {vehicleDetails?.regNo ? vehicleDetails?.regNo : vehicleDetails?.vehImei}
                  </span>
              </div>
          }
          </Col>
          <Col span={24}>
          {showOdometer &&
              <div style={{display: 'flex', paddingTop: '10px',   justifyContent: 'center'}}>
                  <span style={{fontSize: '14px', alignItems: 'center', fontWeight: 600}}>{'Odometer: '}</span>
                  {vehicleDetails?.odometer ? 
                    <span style={{fontSize: '14px', alignItems: 'center', fontWeight: 600}} className="ml05"> {vehicleDetails?.odometer} km </span> 
                  : <span className="disabled ml05">NA</span> }
                  
              </div>
          }
          </Col>
          </Row>
      </div>
    )
}

export default VehicleImageWidget;